import { useRef, type ReactNode } from "react";

import { cn } from "@/lib/utils/cn";

const SPACING = {
  3: "-mb-3 [&>div>div]:pb-3",
  4: "-mb-4 [&>div>div]:pb-4",
} as const;

const OPEN =
  "grid-rows-[1fr] opacity-100 [transition:grid-template-rows_260ms_ease-out,opacity_220ms_ease-out_80ms]";
const CLOSED =
  "pointer-events-none grid-rows-[0fr] opacity-0 [transition:opacity_180ms_ease-out,grid-template-rows_260ms_ease-out_120ms]";

const INERT = { inert: "" } as Record<string, string>;

type CollapseProps = {
  open: boolean;
  children: ReactNode;
  spacing: keyof typeof SPACING;
  as?: "div" | "li";
};

export function Collapse({
  open,
  children,
  spacing,
  as: Tag = "div",
}: CollapseProps) {
  const lastOpenChildren = useRef<ReactNode>(null);
  if (open) lastOpenChildren.current = children;

  return (
    <Tag
      aria-hidden={!open || undefined}
      className={cn(
        "grid motion-reduce:transition-none",
        open ? OPEN : CLOSED,
        SPACING[spacing],
      )}
    >
      <div className="min-h-0 overflow-hidden" {...(!open && INERT)}>
        <div>{open ? children : lastOpenChildren.current}</div>
      </div>
    </Tag>
  );
}
